import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCryptoTon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 20,
		cy: 20,
		r: 20,
		fill: "#2FA6DA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27.8783 11.5C30.1592 11.5001 31.6052 13.9451 30.5072 15.9443L22.1908 31.0869C21.2414 32.8156 18.7584 32.8157 17.809 31.0869L9.49257 15.9443C8.39466 13.9451 9.8407 11.5002 12.1215 11.5H27.8783ZM12.1215 13.5C11.3613 13.5002 10.8796 14.3151 11.2455 14.9814L19.0004 29.1016V13.5H12.1215ZM21.0004 29.1006L28.7543 14.9814C29.1203 14.3151 28.6385 13.5001 27.8783 13.5H21.0004V29.1006Z",
		fill: "white"
	})]
});
export default SvgCryptoTon;
